<template>
  <div>
    <OrderContentFramework :button-name="'提交订单'" :totalMoney="totalMoney"
                           @response="newsubmitOrder" :showButton="showButton">
      <!--默认地址-->
      <div class="content-block" v-if="!isService">
        <img src="static/img/默认flag.png" class="default-flag">
        <div class="block-item">
          <span class="deep-text-color">收货地址</span>
          <div>
            <span style="font-size: 12px; color: #979797;">将商品留在吉凯用于其他项目</span>
            <label class="label-switch">
              <input type="checkbox"  v-model="isExpress" @change="changeExpressFree">
              <div class="checkbox" :style="{'background-color': isExpress ? '#5878fa' : '#e5e5e5'}"></div>
            </label>
          </div>
        </div>
        <div v-show="!isExpress">
          <div class="split-line"></div>
          <router-link :to="{name : 'WeappAddress'}" v-if="deliverAddress" class="block-item" style="height: 81px;">
            <div class="block-address">
              <i class="icon-font emkt-icon-didian research-font-color" style="font-size: 18px;"></i>
              <div class="item-detail">
                <span class="deep-text-color">{{deliverAddress.province + deliverAddress.city + (deliverAddress.district === undefined ? '' : deliverAddress.district) + deliverAddress.expressAddress}}</span>
                <span class="light-text-color">{{deliverAddress.consignee}} {{deliverAddress.expressMobile}}</span>
              </div>
            </div>
            <i class="icon-font emkt-icon-lujing light-text-color"></i>
          </router-link>
          <div class="split-line"></div>
          <!--配送方式-->
          <div class="block-item">
            <span class="deep-text-color">配送方式</span>
            <div style="display: flex;align-items: center;">
              <label class="label-checkbox item-content" style="display: inline-block; margin-right: 10px;">
                <input type="radio" name="deliverMethod" checked>
                <div class="item-media group">
                  <i class="icon icon-form-checkbox i-style" style="width: 20px;height: 20px;"></i>
                </div>
              </label>
              <span class="light-text-color" style="font-size: 14px;">顺丰快递</span>
            </div>
          </div>
        </div>
      </div>
      <!--订单详情-->
      <div class="content-block">
        <ServiceProduct v-if="isService"  ref="service"
                        :order="orderList"
                        :service="isService"
                        @SE="getServiceTotalMoney"/>
        <OrderMerchandises v-else :order="orderForMerchandises"/>
      </div>
      <!--优惠券-->
      <div class="content-block">
        <div class="block-item" @click="goToSelectCoupons">
          <span class="deep-text-color">优惠券</span>
          <div style="font-size: 14px;">
            <span class="light-text-color" v-if="!availableCoupons || availableCoupons.length === 0">无可用</span>
            <span class="light-text-color" v-else-if="displayNameOnlyCoupon">使用1张{{displayNameOnlyCoupon.label}}</span>
            <span class="light-text-color" v-else-if="selectedCoupons.length > 0" >已选择
              <span class="alert-text" >{{selectedCoupons.length}}</span>张优惠券，可抵扣
              <span class="alert-text">¥{{emkt.formatPrice(couponDiscount)}}元</span>
              <!--              <span class="alert-text">¥{{emkt.formatPrice(discountPrice)}}元</span>-->
            </span>
            <span v-else>未选择</span>
            <i class="icon-font emkt-icon-lujing light-text-color"></i>
          </div>
        </div>
      </div>
    </OrderContentFramework>
  </div>
</template>

<script>
    import emkt from './../../emkt'
    import {mapMutations, mapState} from 'vuex'
    import OrderMerchandises from './OrderMerchandises'
    import CouponSelection from './CouponSelection'
    import OrderContentFramework from './OrderContentFramework'
    import $ from 'jquery'
    import wx from 'wx'
    import ServiceProduct from '../../views_fc/Order/ServiceProduct'

    export default {
      data () {
        return {
          serviceProductCanUseCoupons: [],
          materialReceives: [],
          children: [],
          subLines: [],
          isService: false,
          solution: {},
          solutionId: null,
          isExpress: false,
          showCouponSelectionBox: false,
          address: null,
          orderList: [],
          discountPrice: '',
          totalMoney: '',
          goodsMoney: '',
          expressPrice: '',
          specialGuid: '',
                // 用户选择的所有优惠券
          selectedCoupons: [],
                // 用户选择的现金券
          selectCoupon: null,
                // 仅使用折扣券
          useDiscountCouponOnly: false,
          availableCoupons: null,
                // 折扣券优惠券金额
          specialDiscountPrice: 0,
          productInfo: {
            value: null
          },
          showButton: true,
          calculatedPriceMerchandises: [],
                // 购物车数据
          cartContent: null
        }
      },
      components: {
        ServiceProduct,
        OrderMerchandises,
        CouponSelection,
        OrderContentFramework
      },
      beforeRouteEnter (to, from, next) { // 若从活动页面跳转到登录页面，登录成功后返回活动页面
        next(vm => {
          if (from.name && (from.name === 'WeappOrderConfirmation')) {
            vm.gotoWeappCart()
          }
        })
      },
      computed: {
        ...mapState([
          'cartList', 'sessionInfo', 'currentWaitPayOrder', 'secPromotionDetailObj'
        ]),
        // 筑研服务券
        specialFundCoupon () {
          if (!this.selectedCoupons) return null
          const fundCoupon = this.selectedCoupons.filter(cou => cou.type === emkt.COUPON_TYPE_SPECIAL_FUND)[0] || null
          return fundCoupon
        },
        //  新折扣券
        newDiscountCoupon () {
          if (!this.selectedCoupons) return null
          return this.selectedCoupons.filter(cou => cou.type === emkt.COUPON_TYPE_NEW_DISCOUNT)[0] || null
        },
        displayNameOnlyCoupon () {
          return (this.specialFundCoupon || this.newDiscountCoupon)
        },
        orderForMerchandises () {
          return {
            expressPrice: this.expressPrice,
            totalPrice: this.totalMoney,
            price: this.goodsMoney,
            coupons: this.selectCoupon ? [this.selectCoupon] : [],
            merchandises: this.calculatedPriceMerchandises
          }
        },
        deliverAddress () {
          if (!this.address || this.address.length === 0) {
            return null
          }
          const defaultAddress = this.address.find(addre => addre.addressStatus !== emkt.ADDRESS_STATUS.ADDRESS_STATUS_INVALID && (addre.isDefault === 1 || addre.isDefault === 3))
          return defaultAddress || this.address[0]
        },
        couponDiscount () {
          if (!this.selectedCoupons || this.selectedCoupons.length === 0) {
            return 0
          }
          return this.useDiscountCouponOnly ? Math.abs(this.specialDiscountPrice) : (this.selectCoupon && this.selectCoupon.value)
        }
      },
      watch: {
        selectCoupon (val) {
                // 选择现金券后，仅当可用现金券时，重新计算价格
          if (this.useDiscountCouponOnly) return
          if (this.isService) {
            this.$refs.service.getSolutionPriceAgain()
          } else {
            this.fetchTotalMoney()
          }
        },
        'sessionInfo': {
          handler: function (val) {
            if (!val) return
            this.address = this.sessionInfo.expressAddress
            if (this.address === undefined) {
              this.$weui.topTips('请登录', 2000)
                        // $.toast('请登录')
              return
            } else {
              this.orderList && this.orderList.length > 0 && this.fetchTotalMoney()
            }
          },
          immediate: true
        },
        'cartList': {
          handler: 'getCartCheckedProducts',
          immediate: true
        },
        totalMoney (val) {
          if (val && val > 0) {
            this.showButton = true
          }
        }
      },
      mounted () {
      },
      methods: {
        ...mapMutations([
          'SET_CURRENT_WAITPAY_ORDER', 'ADD_CHECK_LIST', 'REMOVE_ALL_CHECKLIST_FROM_CART_LIST'
        ]),
        getServiceTotalMoney (price) {
          console.log('价格传递')
          this.totalMoney = price[0]
        },
        newsubmitOrder () {
          this.gcapi('checkEnterpriseType').then(res => {
            this.submit()
          })
        },
        gotoWeappCart () {
          if (emkt.isWapp) {
            wx.miniProgram.switchTab({
              url: '/pages/cart/cart'
            })
          } else {
            this.$router.replace({name: 'cart'})
          }
        },
        goToSelectCoupons () {
          // 若使用筑研服务抵用券，不支持修改
          if (this.specialFundCoupon) return
                // console.log(this.selectedCoupons, 'bnsjdnvkcslobvucbhsc')
                // this.$router.push({name: 'WeappCouponSelection', query: {availableUniqueCoupons: this.availableCoupons, useDiscountCouponOnly: this.useDiscountCouponOnly, defaultSelectedCoupons: this.selectedCoupons, fromOrderPage: true}})
          this.$router.push({name: 'myCoupons',
            query: {
              availableUniqueCoupons: this.availableCoupons,
              useDiscountCouponOnly: this.useDiscountCouponOnly,
              defaultSelectedCoupons: this.selectedCoupons,
              fromOrderPage: true},
            params: {
              isService: this.isService,
              comeFrom: this.$route.query.comeFrom
            }})
        },
        getCartCheckedProducts () {
          // this.$weui.loading('正在加载数据~')
          if (!this.cartList || !this.cartList.cartContent) return
          let cartContent = this.filterCartData(Object.assign({}, this.cartList.cartContent))
          const products = []
          Object.keys(cartContent).forEach((item) => {
            cartContent[item]['cartId'] = item
            if (cartContent[item].smartAttributes) {
              products.push(emkt.convertProduct(cartContent[item]))
            } else {
              products.push(cartContent[item])
            }
          })
          this.orderList = products.filter(pro => pro.isChecked)
          if (this.orderList.length === 0) {
            return
          }
          if (this.orderList[0].categoryId) {
            console.log('ssssssssssssssss', this.orderList)
            if (this.orderList[0].categoryId === emkt.PRODUCT_TYPE_SERVICE_CONSTANT) {
              this.isService = true
              this.solution = {
                'questionDesc': new Date().getTime() + '问题',
                'name': new Date().getTime() + '方案',
                'diseaseDirection': parseInt(this.orderList[0].allData.diseaseDirectionId),
                'diseaseName': this.orderList[0].allData.diseaseDirectionName,
                'templateId': 1
              }
              let arr = []
              let number = -1
              this.orderList.forEach(item => {
                let object = {
                  'receiveType': 2,
                  'isReceived': 0,
                  'notReceivedType': 1,
                  'sampleType': item.allData.loSampleTypeId, // 样本类型
                  'receiveDesc': item.allData.sampleType, // 样本类型名称
                  'returnType': item.allData.returnMaterialChecked ? 1 : 2,
                  'relatedEuIdList': [] // 关联实验
                }
                this.materialReceives.push(object)
                let euIdGroup = []
                item.allData.boSolution.children.forEach(items => {
                  let puIdGroup = []
                  items.id = number - 1
                  number = number - 1
                  items.children.forEach(it => {
                    it.id = number - 1
                    number = number - 1
                    puIdGroup.push(it.id)
                  })
                  items.groups.forEach(i => {
                    if (i.parameterValues) {
                      if (i.parameterValues.length > 0) {
                        i.parameterValues.forEach(its => {
                          its.value = item.allData.sampleType
                        })
                      }
                    }
                  })
                  items.skuID = item.allData.currSkuId
                  items.otherTaxName = item.allData.otherSampleSpecName
                  console.log(item.allData, items.otherTaxName)
                  items.subLines = []
                  if (puIdGroup.length > 1) {
                    puIdGroup.forEach((iss, index) => {
                      if (index < puIdGroup.length - 1) {
                        items.subLines.push({
                          'northId': puIdGroup[index],
                          'southId': puIdGroup[index + 1]
                        })
                      }
                    })
                  }
                  arr.push(items)
                  euIdGroup.push(items.id)
                })
                if (item.allData.boSolution.children.length === 2) {
                  this.subLines.push({
                    'northId': euIdGroup[0],
                    'southId': euIdGroup[1]
                  })
                }
              })
              this.children = arr
            }
            let arrString = new Set()
            this.children.forEach(item => {
              if (item.template.externalName !== undefined) {
                arrString.add(item.template.externalName)
              }
            })
            let string = ''
            arrString.forEach(item => {
              string = string + item + '、'
            })
            string = string.substr(0, string.length - 1)
            this.solution.questionDesc = string
            this.solution.name = string
            this.ADD_CHECK_LIST(this.orderList)
          }
          if (!this.isService) {
            var cangoNext = true
            // for (var i in this.orderList) {
            //   if (this.orderList[i].newMerch === undefined && (this.orderList[i].manualFileName.indexOf('腺相关') !== -1 || this.orderList[i].manualFileName.indexOf('神经环路标记病毒') !== -1)) {
            //     this.$weui.alert('老师：您好！\n' +
            //         '由于AAV、HSV产品详情内容的调整，您之前添加的该产品，需重新添加至购物车后才能结算下单。\n' +
            //         '感谢您的支持！')
            //     cangoNext = false
            //     return
            //   }
            // }
            if (cangoNext) {
              this.ADD_CHECK_LIST(this.orderList)
              this.orderList && this.address && this.fetchTotalMoney()
            }
          }
          this.$weui.loading('正在加载数据~').hide()
        },
        /**
             * 为了防止购物车工具类和服务类的isChecked都为true，特地添加此过滤方法来确保服务类和工具类产品数据分开
             * service 来源于服务类购物车的跳转,
             * tools来源于工具类购物车的跳转
             * orderService 购物清单中服务类的跳转
             * orderTools 购物清单中工具类的跳转
             * @param data
             * @return {*}
             */
        filterCartData (data) {
          console.log(this.$route)
          if (this.$route.query.comeFrom) {
            if (this.$route.query.comeFrom.includes('ervice')) {
              for (let key in data) {
                if (data[key].categoryId !== emkt.PRODUCT_TYPE_SERVICE_CONSTANT) {
                  delete data[key]
                }
              }
            } else if (this.$route.query.comeFrom.includes('ools')) {
              for (let key in data) {
                if (data[key].categoryId === emkt.PRODUCT_TYPE_SERVICE_CONSTANT) {
                  delete data[key]
                }
              }
            }
            return data
          } else {
            return data
          }
        },
        changeExpressFree () {
          const self = this
          if (self.isExpress === false) {
            self.fetchTotalMoney()
          } else {
            this.$weui.dialog({
              content: '如果选择不发货，商品将留在吉凯基因用于您的其他服务项目。',
              buttons: [{
                label: '取消',
                type: 'default',
                onClick: () => {
                  self.isExpress = false
                }
              }, {
                label: '确定',
                type: 'primary',
                onClick: () => {
                  $.showIndicator()
                  setTimeout(function () {
                    $.hideIndicator()
                  }, 300)
                  self.fetchTotalMoney()
                }
              }]
            })
                    // $.confirm('如果选择不发货，商品将留在吉凯基因用于您的其他服务项目。',
                    //   function () {
                    //     $.showIndicator()
                    //     setTimeout(function () {
                    //       $.hideIndicator()
                    //     }, 300)
                    //     self.fetchTotalMoney()
                    //   },
                    //   function () {
                    //     self.isExpress = false
                    //   })
          }
        },
        autofocus (id) {
          $('#' + id).focus()
        },
        submit () {
          if (this.isService) {
            this.beforeSubmitServiceOrder()
          } else {
            this.submitOrder()
          }
        },
        beforeSubmitServiceOrder () {
          this.$weui.loading('正在提交数据！')
          this.gcapi('loCreateSolution', this.solution).then((res) => {
            if (res.body.code === 0) {
              let data = JSON.parse(res.body.result)
              this.solutionId = data.id
              const object = {
                'id': this.solutionId,
                'children': this.children,
                'subLines': this.subLines,
                'sortOrderManualModified': false
              }
              this.gcapi('loUpdateSolutionTopology', JSON.stringify(object)).then((res) => {
                if (res.body.code === 0) {
                  this.gcapi('loLoadSolutionDetail', this.solutionId).then((res) => {
                    if (res.body.code === 0) {
                      let result = JSON.parse(res.body.result)
                      object.children.forEach((item, index) => {
                        item.groups.forEach(item => {
                          if (item.parameterValues && item.parameterValues.length > 0) {
                            item.parameterValues.forEach(it => {
                              if (it.dataType) {
                                it.duplicateDataType = it.dataType
                              }
                            })
                          }
                        })
                        result.children[index].groups = item.groups
                        result.children[index].parameterValues = item.parameterValues
                        result.children[index].taxId = item.taxId
                        result.children[index].skuId = item.skuID
                        console.log(result.children[index].skuId, 'sdsiuhi')
                        if (item.otherTaxName) {
                          result.children[index].otherTaxName = item.otherTaxName
                        }
                        // 物料关联EU的Id
                        if (this.materialReceives[index]) {
                          this.materialReceives[index].relatedEuIdList = [].concat(result.children[index].id)
                        }
                        console.log(result.children[index].otherTaxName, 'sdsiuhi')
                      })
                      let materialObject = {
                        'materialReceives': this.materialReceives,
                        'solutionId': this.solutionId,
                        'pushMaterialNotification': true // 淘基因下单默认推送实物信息表和送样指南
                      }
                      // 先调用获取方案详情接口 获取每个EU的Id 绑定到实物上 再调用保存方物料信息接口
                      this.gcapi('loSaveMaterialInfo', JSON.stringify(materialObject)).then((res) => {
                        if (res.body.code !== 0) {
                          this.$weui.toast('保存物料信息失败，请联系客服!', 2000)
                        } else {
                          result['id'] = this.solutionId
                          result['orderSource'] = '1'
                          result['operationType'] = 20
                          this.gcapi('loUpdateSolutionInfo', JSON.stringify(result)).then((res) => {
                            this.$weui.loading().hide()
                            this.gcapi('loLoadSolutionDetail', this.solutionId).then((res) => {})
                            this.submitServiceOrder(res.body.result)
                          })
                        }
                      })
                    }
                    console.log(JSON.parse(res.body.result), '方案详情')
                    console.log(object)
                  })
                } else {
                  this.$weui.toast('保存拓扑结构图失败，请联系客服!', 2000)
                }
              })
            } else {
              this.$weui.toast('保存方案失败，请联系客服!', 2000)
            }
          })
        },
        submitServiceOrder (solutionJson) {
          let object = {
            'solutionJsons': [solutionJson],
            'coupons': this.selectedCoupons
          }
          this.gcapi('submitServiceProductOrder', object).then((res) => {
            console.log(res.body, '提交订单返回')
            if (res.body.code === 0) {
              let order = res.body.result
              console.log('submit order', order)
              this.SET_CURRENT_WAITPAY_ORDER(order)
                        //  clear cart content 如果是购物清单的数据，那么将不会清除
              if (this.$route.query.comeFrom !== 'orderService') {
                this.REMOVE_ALL_CHECKLIST_FROM_CART_LIST()
              }
              if (!emkt.isWapp) {
                this.gcapi('retrieveMyOrder').then(response => {
                  this.$router.replace({name: 'WeappOrderConfirmation'})
                })
              } else {
                this.$router.replace({name: 'WeappOrderConfirmation'})
              }
            }
          })
        },
        submitOrder () {
          let bMerchandises = this.productInfo.value
          if (!bMerchandises) {
            return
          }
          let order
          var _this = this
          bMerchandises.orderType = '1'
          _this.$weui.loading('结算中')
                // $.showPreloader('正在进入结算方式页面，请稍等')
          _this.showButton = false
          _this.gcapi('orderSubmit', bMerchandises).then(response => {
            if (response.body.code === 1) {
              _this.$weui.topTips(response.body.message, 6000)
                        // $.toast(response.body.message)
              return
            }
            order = response.body.result
            order.expressFree = this.productInfo.value.expressFree
            console.log('submit order', order)
            _this.SET_CURRENT_WAITPAY_ORDER(order)
                    //  clear cart content 如果源自于购物清单，则不清除购物车中的数据
            if (this.$route.query.comeFrom !== 'orderTools') {
              this.REMOVE_ALL_CHECKLIST_FROM_CART_LIST()
            }
                    // todo push-replace
                    // this.$router.replace({name: 'WeappOrderConfirmation'})
          }).then(function () {
            _this.$weui.loading().hide()
            _this.$router.replace({name: 'WeappOrderConfirmation'})
            // if (!emkt.isWapp) {
            //   _this.gcapi('retrieveMyOrder').then(response => {
            //     _this.$weui.loading().hide()
            //     _this.$router.replace({name: 'WeappOrderConfirmation'})
            //   })
            // } else {
            //   _this.$weui.loading().hide()
            //   _this.$router.replace({name: 'WeappOrderConfirmation'})
            // }
          })
        },
        getRemark (result) {
          for (var i = 0; i < result.merchandises.length; i++) {
            for (var j = 0; j < this.productInfo.value.merchandises.length; j++) {
              if (result.merchandises[i].merchandiseGuid === this.productInfo.value.merchandises[j].merchandiseGuid) {
                this.productInfo.value.merchandises[j].remark = result.merchandises[i].remark
              }
                        // 定制产品判断cartID，目前不需要考虑
                        // else {
                        //   if (result.merchandises[i].merchandiseGuid === this.productInfo.value.merchandises[j].merchandiseGuid) {
                        //     this.productInfo.value.merchandises[j].remark = result.merchandises[i].remark
                        //   }
                        // }
            }
          }
        },
        getAvailableCoupons (result, havePu) {
          this.$forceUpdate()
          var useSpecialCoupon = false
          if (this.isService) {
            let os = []
            let proId = emkt.getLocalStorage('EmktPromotions')
            this.$refs.service.puCouponsGuid.forEach(item => {
              proId.forEach(it => {
                if (item) {
                  if (item === it.promotionGuid) {
                    os.push(it)
                  }
                }
              })
            })
            os.forEach(osItem => {
              if (osItem.description) {
                if (osItem.description.includes('不同享')) {
                  result = []
                }
              }
            })
            os.some(osItem => {
                        // console.log('os', osItem)
              if (osItem.requiredCustomers) {
                if (osItem.requiredCustomers === 1) {
                  let pros = osItem
                  let endDT = new Date(pros.endDT.year, pros.endDT.month, pros.endDT.dayOfMonth, pros.endDT.hourOfDay, pros.endDT.minute, pros.endDT.second)
                  let statrDT = new Date(pros.startDT.year, pros.startDT.month, pros.startDT.dayOfMonth, pros.startDT.hourOfDay, pros.startDT.minute, pros.startDT.second)
                  let startDT1 = this.FormatterTime(statrDT).replace(/-/g, '/')
                  let endDT1 = this.FormatterTime(endDT).replace(/-/g, '/')
                  let newCoupon = {
                    'promotionGuid': pros.promotionGuid,
                    'code': this.sessionInfo.customerInfo.customerNo + pros.promotionGuid,
                    'customerNo': this.sessionInfo.customerInfo.customerNo,
                    'type': emkt.COUPON_TYPE_DISCOUNT,
                    'label': pros.name,
                    'startDT': startDT1,
                    'endDT': endDT1,
                    'description': pros.description,
                    'quantity': pros.quantity
                  }
                  useSpecialCoupon = true
                  result.push(newCoupon)
                  this.specialGuid = newCoupon.promotionGuid
                  return true
                }
              }
            })
            this.useDiscountCouponOnly = useSpecialCoupon
                    // 此订单可以使用的所有优惠券，包括折扣券和现金券
            let couponlist = []
            for (let j = 0; j < result.length; j++) {
              let flag = true
              couponlist.forEach(item => {
                if (result[j].code === item.code) {
                  flag = false
                }
              })
              if (flag) {
                couponlist.push(result[j])
              }
            }
            this.availableCoupons = [...couponlist].sort((a, b) => {
              return a.type - b.type
            })
            this.availableCoupons.forEach(coupon => {
              coupon.available = true
            })
          } else {
            for (var i = 0; i < result.merchandises.length; i++) {
              for (var j = 0; j < this.productInfo.value.merchandises.length; j++) {
                if (result.merchandises[i].merchandiseGuid === this.productInfo.value.merchandises[j].merchandiseGuid) {
                  this.productInfo.value.merchandises[j].remark = result.merchandises[i].remark
                }
              }
              if (result.merchandises[i].perferPromotions) {
                for (var k = 0; k < result.merchandises[i].perferPromotions.length; k++) {
                  if (result.merchandises[i].perferPromotions[k].description.includes('不同享')) {
                    result.coupons = []
                  }
                  if (result.merchandises[i].perferPromotions[k].requiredCustomers === 1) {
                    var pro = result.merchandises[i].perferPromotions[k]
                    let endDT = new Date(pro.endDT.year, pro.endDT.month, pro.endDT.dayOfMonth, pro.endDT.hourOfDay, pro.endDT.minute, pro.endDT.second)
                    let statrDT = new Date(pro.startDT.year, pro.startDT.month, pro.startDT.dayOfMonth, pro.startDT.hourOfDay, pro.startDT.minute, pro.startDT.second)
                    var startDT1 = this.FormatterTime(statrDT).replace(/-/g, '/')
                    var endDT1 = this.FormatterTime(endDT).replace(/-/g, '/')
                    var newcoupon = {
                      'promotionGuid': pro.promotionGuid,
                      'code': pro.promotionGuid + 'zhe',
                      'customerNo': this.sessionInfo.customerInfo.customerNo,
                      'type': emkt.COUPON_TYPE_DISCOUNT,
                      'label': pro.name,
                      'startDT': startDT1,
                      'endDT': endDT1,
                      'description': pro.description,
                      'quantity': pro.quantity
                    }
                    useSpecialCoupon = true
                    result.coupons.push(newcoupon)
                    break
                  }
                }
              }
            }
            this.useDiscountCouponOnly = useSpecialCoupon
                    // 此订单可以使用的所有优惠券，包括折扣券和现金券
            var couponlist = []
            for (let j = 0; j < result.coupons.length; j++) {
              var flag = true
              couponlist.forEach(item => {
                if (result.coupons[j].code === item.code) {
                  flag = false
                }
              })
              if (flag) {
                couponlist.push(result.coupons[j])
              }
            }
            this.availableCoupons = [...couponlist].sort((a, b) => {
              return a.type - b.type
            })
            this.availableCoupons.forEach(coupon => {
              coupon.available = true
            })
          }
        },
        setDefaultSelectedCoupons () {
                // console.log(this.$route.query.chosenCoupons, '选择的优惠券')
          if (!this.availableCoupons || this.availableCoupons.length === 0) return
                // 若从选择优惠券界面返回，设置为用户选择的优惠券
          const chosenCoupons = this.$route.query.chosenCoupons
          if (chosenCoupons && Array.isArray(chosenCoupons)) {
            return this.updateSelectCoupon(this.$route.query.chosenCoupons)
          }
                // 若存在折扣券，目前只支持选择折扣券
          if (this.useDiscountCouponOnly) {
            this.$weui.toast('已为您选择折扣券！', 1500)
            this.selectedCoupons = this.availableCoupons.filter(cou => cou.type === emkt.COUPON_TYPE_DISCOUNT)
          } else {
                    // 选择金额最大的现金券
            this.availableCoupons.sort((a, b) => {
              return b.value - a.value
            })
            this.selectCoupon = this.availableCoupons[0]
            this.selectedCoupons = [this.selectCoupon]
            this.$refs.service.getSolutionPriceAgain()
          }
        },
        updateMerchandisesAttributes (merchandises) {
                // 更新计算价格后的商品属性，包括基因等信息，通过cartId与购物车商品关联
          if (!merchandises) return
          const filteredMerchandises = merchandises.filter(mer => mer.presentQuantity === 0)
          const combinedMerchandises = []
          this.orderList.forEach((cartMer) => {
            const updatedMerchandise = filteredMerchandises.find(mer => cartMer.cartId === mer.cartId)
            if (!updatedMerchandise) {
              console.log('购物车中无此商品cartID=' + cartMer.cartId)
            } else {
              delete updatedMerchandise._attributesList
              delete updatedMerchandise._titleList
              delete updatedMerchandise._subTitleList
              delete updatedMerchandise._abstractList
              let combined = Object.assign({}, cartMer, updatedMerchandise)
              combinedMerchandises.push(combined)
            }
          })
          console.log('combinedMerchandises', combinedMerchandises)
          return combinedMerchandises
        },
        fetchTotalMoney () {
          var self = this
          let bMerchandises = this.getProductInfo()
          if (!bMerchandises) {
            return
          }
          this.gcapi('calculateOrderAmount', bMerchandises).then(data => {
            let result = data.body.result
            if (!result) return
                    // 若当前未获取优惠券，获取可选择的优惠券并默认选择最优优惠券
            console.log('this.availableCoupons--->', this.availableCoupons)
            if (this.availableCoupons === null) {
              this.getAvailableCoupons(result)
              this.setDefaultSelectedCoupons()
            } else {
              this.getRemark(result)
            }
                    // console.log(this.productInfo)
            this.totalMoney = 0
            this.goodsMoney = 0
            this.expressPrice = 0
            this.goodsMoney = result.price
            this.totalMoney = result.totalPrice
            this.expressPrice = result.expressPrice
            this.calculatedPriceMerchandises = this.updateMerchandisesAttributes(result.merchandises)
                    // 计算特殊的打折券的折扣金额
            const specialcouponpromotions = emkt.getLocalStorage('EmktSpecialcouponpromotions')
            let specialDiscountPrice = 0
            if (specialcouponpromotions && specialcouponpromotions.length > 0) {
              const specialCouponPromotionGuids = specialcouponpromotions.map(pro => pro.promotionGuid)
              result.merchandises.forEach(merchandise => {
                const preferPromitionGuid = merchandise.perferPromotions && merchandise.perferPromotions.length > 0 && merchandise.perferPromotions[0].promotionGuid
                specialDiscountPrice += (preferPromitionGuid && specialCouponPromotionGuids.includes(preferPromitionGuid)) ? merchandise.discountPrice : 0
              })
            }
            this.specialDiscountPrice = specialDiscountPrice
            console.log('specialDiscountPrice', specialDiscountPrice, specialcouponpromotions)
            this.discountPrice = result.discountPrice ? Math.abs(+result.discountPrice) : (specialDiscountPrice ? Math.abs(+specialDiscountPrice) : 0)
            if (+this.totalMoney < 0) {
              this.$weui.dialog({
                title: '订单出现异常，请联系客服',
                buttons: [{
                  label: '确定',
                  type: 'primary',
                  onClick: () => {
                    self.$router.go(-1)
                  }
                }]
              })
            }
          })
        },
        getProductInfo () {
          var self = this
          let border = {}
          if (this.address === undefined) {
            this.$weui.topTips('请登录', 2000)
                    // $.toast('请登录')
            return
          } else {
            let addr = this.deliverAddress
            if (!addr && this.sessionInfo.customerInfo.ssoFlag === 0) {
              this.$weui.dialog({
                title: '请先添加收货地址',
                buttons: [{
                  label: '确定',
                  type: 'primary',
                  onClick: () => {
                    self.$router.push({name: 'WeappAddress'})
                  }
                }]
              })
              return
            }
            let city = addr.city === undefined ? '' : addr.city
            let district = addr.district === undefined ? '' : addr.district
            border.expressAddress = city + district + addr.expressAddress
            border.expressPhone = addr.expressMobile
            border.expressContactor = addr.consignee
            border.isSingleExpress = true
          }
          let coupons = []
          if (!this.useDiscountCouponOnly) {
            let coupon = this.selectCoupon
            if (coupon) {
              if (this.selectCoupon.type !== 0) {
                coupons.push(coupon)
              }
            }
          }
          border.coupons = coupons

          let bMerchandises = []
          if (this.orderList === undefined) {
            this.$weui.topTips('读取数据失败', 2000)
                    // $.toast('读取数据失败')
            return
          }
          if (emkt.getUrlParamHref('fromSmart') === '1') {
            border.isSmartOrder = true
            border.bsmartProducts = []
            this.orderList.forEach(item => {
              let pro = {
                guid: item.guid,
                smartProductParameterSelection: item.smartProductParameterSelection
              }
              let bMerchandise = {}
              bMerchandise.price = item.price
              bMerchandise.expressPrice = item.expressPrice
              bMerchandise.merchandiseGuid = item.guid
              bMerchandise.workdays = item.workdays
              bMerchandise.priceMax = item.price
              bMerchandise.priceMin = item.price
              bMerchandise.unitPrice = item.price
              bMerchandise.initPrice = item.price
              bMerchandise.SKUID = item.SKUID
              bMerchandise.cartId = item.cartId
              bMerchandise.productName = item.productName
              bMerchandise.productGuid = item.productGuid
              bMerchandise.muGuid = item.muGuid
              bMerchandise.isSmartMerchandise = true
              bMerchandise.attributes = item.smartAttributes.map(attr => ({...attr, dataType: attr.dataType}))
              bMerchandises.push(bMerchandise)
              border.bsmartProducts.push(pro)
            })
          } else {
            for (let i = 0; i < this.orderList.length; i++) {
              console.log('this.orderList', this.orderList)
              let bMerchandise = {}
              let order = this.orderList[i]
              if (order.categoryId !== 10) {
                bMerchandise.merchandiseGuid = order.merchandiseId
                // 记录商品的cartId
                bMerchandise.cartId = order.cartId
              } else {
                if (order.merchandiseId.toString().indexOf('Customized01') === -1) {
                  alert('提交商品中包含审核失败的报价，请您修改商品再提交审核')
                  // todo return cart
                  this.$router.push({name: 'cart'})
                  return
                }
                bMerchandise.merchandiseGuid = order.goodsNo
                bMerchandise.merchandiseId = order.goodsNo
              }
              if (order.id) {
                bMerchandise.orderGuid = order.id
              }
              bMerchandise.newMerch = order.newMerch
              bMerchandise.unitPrice = order.priceMin
              bMerchandise.selfOperated = order.selfOperated
              bMerchandise.customerGuid = this.sessionInfo.customerInfo.customerGuid
              bMerchandise.quantity = order.productQuantity
              bMerchandise.merchantNo = order.MerchantNo
              bMerchandise.amplification = order.amplification
              bMerchandise.categoryId = order.categoryId
              bMerchandise.priceMax = order.priceMax
              bMerchandise.priceMin = order.priceMin
              bMerchandise.initPrice = bMerchandise.quantity * bMerchandise.unitPrice
              let productGuid = order.productGuid
              if (productGuid) {
                bMerchandise.productGuid = productGuid
              }
              let cusGuid = order.expressPrice
              if (cusGuid) {
                bMerchandise.expressPrice = cusGuid
              }
              let attributes = []
              Object.keys(order.attributes).forEach(function (key) {
                if (order.attributes[key] instanceof Object) {
                  if (key === 'GeneInfo') {
                    attributes.push({key: key, value: order.attributes[key].geneGUID})
//                attributes.push({key: 'NMID', value: order.attributes[key].NMID})
                  }
                  if (key === 'TVInfo') {
                    attributes.push({key: key, value: order.attributes[key].TLNo})
                  }
                } else {
                  if (key === 'GeneInfo') {
                    if (order.attributes[key] === -1) {
                      attributes.push({key: 'GeneInfo.category', value: -1})
                    }
//                attributes.push({key: 'NMID', value: order.attributes[key].NMID})
                  }
                  attributes.push({key: key, value: order.attributes[key]})
                }
              })
              bMerchandise.attributes = attributes

              bMerchandises[i] = bMerchandise
            }
          }
          border.merchandises = bMerchandises
          border.expressFree = this.isExpress
          border.usedBonus = false
          border.customerVipPlanNo = this.customerVipPlanNo
          if (emkt.isWapp) {
            border.clientSource = '3'
          } else {
            border.clientSource = '1'
          }
          self.productInfo.value = border
          return border
        },
        FormatterTime (date) {
          let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
          let currentDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
          let currenthours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
          let currentMinutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
          let currentSeconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
          var newTime = date.getFullYear() + '-' + month + '-' + currentDate + ' ' + currenthours + ':' + currentMinutes + ':' + currentSeconds
          return newTime
        },
        updateSelectCoupon (coupons) {
          this.selectedCoupons = coupons
          this.selectCoupon = coupons && coupons.find(coupon => coupon.type !== emkt.COUPON_TYPE_DISCOUNT)
          if (this.isService) {
            console.log(-this.$refs.service.solutionPrice.discountPrice)
            this.discountPrice = -this.$refs.service.solutionPrice.discountPrice
          }
          console.log('updateSelectCoupon selectedCoupons selectCoupon', this.selectedCoupons, this.selectCoupon)
        }
      }
    }
</script>

<style scoped>

  .tiny-font {
    font-size: 12px;
    transform: scale(0.8);
    transform-origin: left center;
  }
  .deep-text-color {
    color: #424242;
    font-size: 14px;
    font-weight: 700;
    /*font-weight: bold;*/
  }
  .bold-text {
    font-weight: bold;
  }
  .light-text-color {
    color: #929292;
    font-size: 12px;
  }
  .alert-text {
    color: #FE654D;
  }
  .container {
    overflow-y:scroll;
    overflow-x:hidden;
    height:100vh;
    position: relative;
    background-color:#FAFAFA;
  }
  .order-content {
    /*border: 1px solid #000000;*/
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 86px;
    overflow: scroll;
    padding: 10px;
    padding-bottom: 0;
    font-size: 12px;
  }
  .footer {
    position: fixed;
    bottom:0;
    left: 0;
    width: 100%;
    font-size: 14px;
    height: 86px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    padding: 0 10px;
  }
  .content-block {
    position: relative;
    border: 0.5px solid #EFEEF3;
    margin-top: 0;
    margin-bottom: 10px;
    padding: 0 15px;
    border-radius: 10px;
    width: 100%;
    background-color: #fff;
  }
  .default-flag {
    width: 30px;
    position: absolute;
    left: 0;
    top: 0;
  }
  .block-item {
    height: 62px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
  }
  .block-address {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 90%;
  }
  .item-detail {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 10px;
    width: 85%;
  }
  .text-overflow-hidden {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .price-info {
    text-align: right;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
  .pay-btn {
    width: 110px;
    height: 34px;
    border-radius: 17px;
    line-height: 34px;
    color: #fff;
    text-align: center;
  }
  .return-btn {
    width: 110px;
    height: 34px;
    border-radius: 17px;
    line-height: 34px;
    text-align: center;
    background-color: #fff;
    border:1px solid #5878fa;
  }
  .customer-service {
    margin-left: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .split-line {
    border-top: .5px solid #efeef3;
    margin-right: -15px;
    height: 1px;
  }
  label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox:after {
    background: no-repeat center;
    background-image: url('/static/img/tick.png');
    background-size: .6rem .45rem;
  }

  label.label-checkbox input[type=radio]:checked+.item-media i.icon-form-checkbox {
    background-color: #5878fa;
    border: none;
  }
  .background-modal {
    opacity: 0.55;
    background: #000000;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10;
  }
  .choose-balance-account, .choose-pay-method {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    margin: 0 10px;
    z-index: 20;
    font-size: 14px;
    color: #979797;
  }
  .verity-info {
    text-align: left;
    font-size: 14px;
    color: #979797;
    font-weight: normal;
    width: 50%;
    outline: none;
    border: none;
    padding: 0;
  }
  .verify-account {
    background-color: #FAFAFA;
    padding: 10px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 30;
    font-size: 14px;
  }
  .remind-info {
    line-height: 20px;
    padding: 0 10px;
  }
</style>



// WEBPACK FOOTER //
// OrderContentConfirmation.vue?9e42af56